<template>
  <simple-dropdown tabindex="-1">
    <template v-slot:dropdownMenu>
      <ul>
        <li>
          <button @click="$emit('copyFormValue')">Copy Current Values</button>
        </li>
        <li>
          <button @click="$emit('pasteFormValue')">Paste to this Form</button>
        </li>
      </ul>
    </template>
  </simple-dropdown>
</template>

<script>
import SimpleDropdown from "@/components/SimpleDropdown";
export default {
  name: "CreateMultiBoxDropDown",
  components: { SimpleDropdown },
};
</script>

<style scoped></style>
